import { useEffect } from "react";
import styled from "styled-components";
import Loader from "../Loader/Loader";
import { getTranscriptUrl } from "../../utils/urls";

const Container = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export default function Redirect() {
  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const transcriptJobId = searchParams.get("transcriptJobId");
    const orderId = searchParams.get("orderId");

    const transcriptUrl = orderId
      ? getTranscriptUrl({ uuid: orderId, isOrderingUser: true })
      : transcriptJobId
        ? getTranscriptUrl({ uuid: transcriptJobId, isOrderingUser: false })
        : '';
    if (transcriptUrl) {
      window.location.href = transcriptUrl;
    }
  }, []);

  return (
    <Container>
      <Loader />
    </Container>
  );
}
